import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

import {
  Segment,
} from 'semantic-ui-react';

const AppointmentCard = ({ timestamp }) => {
  const date = moment(timestamp);
  return (
    <Segment textAlign="center" className="AppointmentCard">
      <p className="year">{date.format('YYYY')}</p>
      <div className="dayMonth">
        <p className="day">{date.format('DD')}</p>
        <p className="month">{date.format('MMMM')}</p>
      </div>
      <p className="time">{date.format('hh:mm a')}</p>
    </Segment>
  );
};

AppointmentCard.propTypes = {
  timestamp: PropTypes.string,
};

export default AppointmentCard;



// WEBPACK FOOTER //
// ./src/containers/Lawyer/AppointmentCard.jsx